import { render, staticRenderFns } from "./Decider.vue?vue&type=template&id=dffe82cc&"
import script from "./Decider.vue?vue&type=script&lang=js&"
export * from "./Decider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports